module.exports = __webpack_public_path__ + "media/images/common/fp/icon-format-f0d8f20ef962f24fa44f53f004e4f576.svg";